module.exports = __webpack_public_path__ + "static/media/codeQuiz.66120e4c.png";